<template>
  <div class="card" v-show="currentCardId == cardId">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>{{ title }}</h2>
        <p>{{ description }}</p>
      </div>
      <div class="card-content">
        <el-input
          type="textarea"
          :value="fieldValue"
          :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
          :class="inputClass"
          @input="onInput"
        />
        <div class="attention-limit character" v-if="hasError">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useEntrySheetFormatData } from '@/composables/format-edit/useEntrySheetHistories'

const props = defineProps<{
  cardId: string
  currentCardId?: string
  title: string
  description: string
  fieldKey: string
  errorKey: string
  previewErrors: Record<string, string>
  textareaMinRows?: number
  inputClass?: string
}>()

const formatData = useEntrySheetFormatData() as Record<string, unknown>

const fieldValue = computed(() => String(formatData[props.fieldKey] ?? ''))
const hasError = computed(() => !!props.previewErrors[props.errorKey])
const textareaMinRows = computed(() => props.textareaMinRows ?? 3)

function onInput(value: string) {
  formatData[props.fieldKey] = value
}
</script>
